import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import React, { useContext } from "react";
import { WarningIcon } from "../icons";
import { ThemeProviderContext } from "../ThemeProvider";
import { COLUMN_POSITION_ENDS, COLUMN_POSITION_STARTS } from "../types";
import { GROUPED_ITEM_SPACING_CLASS_MAP } from "../utils/constants";
export const CheckboxContext = React.createContext({
    size: "medium",
    itemSpacing: "none",
    hasError: false,
    backgroundStyle: "transparent",
});
export const CheckboxGroup = ({ children, size = "medium", label, labelClassName = "", hideLabel = false, isRequired, helperText, errorText, itemSpacing = "normal", className = "", testId, orientation = "vertical", labelColumnStart = 2, labelColumnEnd = 5, inputColumnStart = 7, inputColumnEnd = 13, backgroundStyle = "transparent", }) => {
    const theme = useContext(ThemeProviderContext);
    const labelClasses = [
        size === "large" && "text-md",
        size === "medium" && "text-sm",
        !helperText && ["mb-1.5", labelClassName],
    ];
    const labelWrapperClasses = GROUPED_ITEM_SPACING_CLASS_MAP[itemSpacing];
    return (_jsx(CheckboxContext.Provider, { value: {
            size,
            hasError: !!errorText,
            itemSpacing,
            backgroundStyle,
        }, children: _jsxs("div", { className: classNames(orientation === "horizontal" && ["grid", "grid-cols-12"], className), style: { overflowWrap: "anywhere" }, [theme.testAttribute]: testId, children: [_jsxs("div", { className: classNames(orientation === "horizontal" && [
                        COLUMN_POSITION_STARTS[labelColumnStart],
                        COLUMN_POSITION_ENDS[labelColumnEnd],
                    ], labelWrapperClasses), "aria-label": hideLabel ? label : "", children: [!hideLabel && (_jsxs("div", { className: classNames("mb-0.5", errorText
                                ? [
                                    "font-semibold",
                                    "text-text-critical dark:text-text-critical-darkmode",
                                ]
                                : "text-text-subdued dark:text-text-subdued-darkmode", orientation === "horizontal" && "mt-0.25", labelClasses), children: [isRequired && (_jsx("span", { className: "text-text-attention dark:text-text-attention-darkmode mr-0.5", children: "*" })), label] })), errorText && (_jsxs("div", { className: "text-text-critical dark:text-text-critical-darkmode text-sm mb-0.5", children: [_jsx(WarningIcon, { className: "mr-0.5", size: "sm" }), errorText] })), helperText && (_jsx("div", { className: "text-sm text-text-subdued dark:text-text-subdued-darkmode mb-0.5", children: helperText }))] }), _jsx("div", { className: classNames(orientation === "horizontal" && [
                        COLUMN_POSITION_STARTS[inputColumnStart],
                        COLUMN_POSITION_ENDS[inputColumnEnd],
                    ], "grid w-fit"), children: children })] }) }));
};
//# sourceMappingURL=CheckboxGroup.js.map